import { ForwardToPartnersContent } from './forward-to-partners-content';
import type { ActionTypeDescriptor } from '../action-node-editor.types';

export const forwardToPartnersDescriptor: ActionTypeDescriptor = {
  value: 'forwardToPartners',
  label: 'Forward to partners',
  Content: ForwardToPartnersContent,
  getPayload: (values) => ({
    value: values.value,
  }),
};
